import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from '../auth/auth.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthService } from '@doddly/core';
import { InputTextModule } from 'primeng/inputtext';
import { CalloutComponent, IconComponent, LogoComponent } from '@doddly/shared';

@Component({
  selector: 'ly-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AuthComponent,
    InputTextModule,
    CalloutComponent,
    LogoComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  invalidEmail = false;
  successMessage = false;
  forgotPasswordForm = new FormGroup({
    email: new FormControl('', { nonNullable: true }),
  });

  constructor(private auth: AuthService) {}

  submit(): void {
    const email = this.forgotPasswordForm.controls.email.value;
    this.invalidEmail = false;
    this.successMessage = false;

    this.auth
      .sendPasswordResetEmail(email)
      .then(() => {
        this.successMessage = true;
      })
      .catch(() => {
        this.invalidEmail = true;
      });
  }
}
